import type { ReactNode } from 'react';

import { useInterstateTheme } from '@interstate/components/InterstateThemeProvider';
import type { ScenarioGridRowKey } from '@makemydeal/dr-dash-store/types/scenarioGridTypes';

import { RowLabel, RowRoot, RowValue } from '../ScenarioGrid.style';

type ScenarioRowProps = {
    rowKey: ScenarioGridRowKey;
    label?: ReactNode;
    inputId?: string;
    children: ReactNode;
};

export const ScenarioRow = ({ rowKey, label, inputId, children }: ScenarioRowProps) => {
    const theme = useInterstateTheme();
    const cells =
        label === undefined ? (
            children
        ) : (
            <>
                <RowLabel theme={theme}>{inputId ? <label htmlFor={inputId}>{label}</label> : label}</RowLabel>
                <RowValue>{children}</RowValue>
            </>
        );

    return (
        <RowRoot theme={theme} data-row={rowKey} data-testid={`scenario-row-${rowKey}`}>
            {cells}
        </RowRoot>
    );
};
